import type { ReactNode } from 'react';

type Level = 2 | 3;

interface AnchorHeadingProps {
  id: string;
  level?: Level;
  children: ReactNode;
  className?: string;
}

/**
 * Section heading with a stable id and a shareable # permalink.
 */
export function AnchorHeading({ id, level = 2, children, className }: AnchorHeadingProps) {
  const Tag = level === 3 ? 'h3' : 'h2';
  const classes = ['api-anchor-heading', className].filter(Boolean).join(' ');

  return (
    <Tag id={id} className={classes}>
      <a className="api-anchor-link" href={`#${id}`} aria-label="Link to this section">
        #
      </a>
      <span className="api-anchor-label">{children}</span>
    </Tag>
  );
}
